import React from 'react'
import '../vendor/sentry'
import App from '../App'
import config from '../config'
import canny from '../vendor/canny'
import { bootstrapRoot } from '../bootstrapRoot'

// bootstrap
import { initializeLaunchDarkly } from '../featureFlags'

initializeLaunchDarkly().finally(() => {
  bootstrapRoot(<App />)
})

if (config.user.role === 'admin' && import.meta.env.MODE === 'production') {
  canny()
}
